module.exports = __webpack_public_path__ + "img/Aren-Wells.6edf2d9a.webp";